module.exports = __webpack_public_path__ + "img/20200312104134360截图20190822215220912.8c0621c9.jpg";